import {Field, FieldProps, useFormikContext} from "formik";
import React, {useEffect, useState} from "react";
import {IManagementStore} from "Stores/Management/types";
import {IValuesStore} from "Stores/Values/types";
import {Grid} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import CreateIcon from "@material-ui/icons/Create";
import {LogoPreview, LogoControlGrid, LogoInputLabel, LogoInput} from "./styles";
import {Values} from "Tools/Values";

interface IProps {
    fieldName?: string;
    fileFieldName?: string;
    label: string;
    management?: IManagementStore;
    values?: IValuesStore;
    imageFile?: any;
    imageUrl: string
    hasImageSet: boolean;
}

export const LogoField = (props: IProps) => {
    const [imgUrl, setImgUrl] = useState<string>();
    const formikProps = useFormikContext();

    const handleFileChange = (e: any) => {
        e.persist();
        setImgUrl(URL.createObjectURL(e.currentTarget.files[0]))
        console.log(e.currentTarget.files[0])
        formikProps.setFieldValue(props.fileFieldName as string, e.currentTarget.files[0]);
    };

    const handleResetFile = () => {
        setImgUrl(null);
        (document.querySelector("#fileInput") as HTMLInputElement).value = null;
        formikProps.setFieldValue(props.fileFieldName as string, new File([], 'reset'));
    };

    const handleOpen = () => {
        const fileNode: any = document.querySelector("#fileInput");
        fileNode.click();
    };

    useEffect(() => {
        if (props.imageUrl) {
            setImgUrl(props.imageUrl)
        }
    }, []);

    return (
        <>
            <Field
                name={props.fieldName}
                render={({field}: FieldProps) => (
                    <LogoInput
                        type="file"
                        label={props.label}
                        onChange={(e: any) => handleFileChange(e)}
                        id="fileInput"
                        inputProps={{accept: 'image/*'}}
                        InputLabelProps={{shrink: true}}
                    />
                )}
            />

            <Grid container justify="flex-start" alignItems="center">
                <Grid item xs={12}>
                    <LogoInputLabel>{props.label}</LogoInputLabel>
                </Grid>

                {imgUrl && (
                    <Grid item>
                        <LogoPreview src={imgUrl} alt="Application logo"/>
                    </Grid>
                )}


                <LogoControlGrid item container alignItems="center">
                    {imgUrl ? (
                        <>
                            <Grid item>
                                <RoundButton
                                    icon={<CreateIcon/>}
                                    tooltipTitle={Values.getLocalizationValue('edit')}
                                    onClick={() => handleOpen()}
                                    color="default"
                                />
                            </Grid>

                            <Grid item>
                                <RoundButton
                                    icon={<ClearIcon/>}
                                    tooltipTitle={Values.getLocalizationValue('remove')}
                                    onClick={() => handleResetFile()}
                                    color="red"
                                />
                            </Grid>
                        </>
                    ) : (
                        <AddButton onClick={() => handleOpen()} text="Upload image"/>
                    )}
                </LogoControlGrid>
            </Grid>
        </>
    )
}
